import { Reveal } from "@components/ui";
import downloadIcon from "@assets/images/vuesax-bold-document-download.svg";
import warningIllustration from "@assets/images/safety-warning-illustration.svg";

/* Inline SVG icons per card */
function FlameIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22C16.4183 22 20 18.4183 20 14C20 8 12 2 12 2C12 2 4 8 4 14C4 18.4183 7.58172 22 12 22Z" stroke="#f24d2b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 22C14.2091 22 16 19.9853 16 17.5C16 14 12 10 12 10C12 10 8 14 8 17.5C8 19.9853 9.79086 22 12 22Z" stroke="#f24d2b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function InspectIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 22L18 18" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 11H14M11 8V14" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ExtinguisherIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 2H9C7.89543 2 7 2.89543 7 4V20C7 21.1046 7.89543 22 9 22H15C16.1046 22 17 21.1046 17 20V4C17 2.89543 16.1046 2 15 2Z" stroke="#dc2626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 2V6M7 10H17M10 6H14" stroke="#dc2626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function PeopleIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#7c3aed" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 21V19C3 16.7909 4.79086 15 7 15H11C13.2091 15 15 16.7909 15 19V21" stroke="#7c3aed" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 3.13C17.7699 3.58316 19.0078 5.17816 19.0078 7.005C19.0078 8.83184 17.7699 10.4268 16 10.88" stroke="#7c3aed" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21 21V19C20.9896 17.1838 19.7578 15.5983 18 15.14" stroke="#7c3aed" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function FolderIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H9L11 6H20C21.1046 6 22 6.89543 22 8V19Z" stroke="#0d9488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

const safetyCards = [
  {
    title: "Cautions",
    description:
      "Keep flames under supervision, ensure burner jets are clean, never leave pans unattended.",
    icon: <FlameIcon />,
    color: "#f24d2b",
  },
  {
    title: "Checks",
    description:
      "Schedule monthly leak testing and quarterly pressure checks.",
    icon: <InspectIcon />,
    color: "#2563eb",
  },
  {
    title: "Emergency/Fire extinguisher",
    description:
      "Keep fire extinguishers and emergency shut-off valves clearly marked.",
    icon: <ExtinguisherIcon />,
    color: "#dc2626",
  },
  {
    title: "Staff Training",
    description:
      "Train staff annually on emergency response and evacuation procedures.",
    icon: <PeopleIcon />,
    color: "#7c3aed",
  },
  {
    title: "Record Keeping",
    description:
      "Maintain records of inspections and Civil Defense certificates.",
    icon: <FolderIcon />,
    color: "#0d9488",
  },
];

export function SafetyGuidelinesSection() {
  return (
    <section className="w-full bg-white overflow-hidden px-5 md:px-10 lg:px-[180px] py-12 md:py-16 lg:py-[120px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-10 md:gap-14 font-albert-sans">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8">
            <div className="flex flex-col items-start gap-4 md:gap-8">
              {/* Pill Badge */}
              <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#f24d2b]/8 text-[#f24d2b] text-[13px] md:text-[15px] font-semibold tracking-[-0.04em] uppercase">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.91 11.12C20.91 16.01 17.36 20.59 12.51 21.93C12.18 22.02 11.82 22.02 11.49 21.93C6.64 20.59 3.09 16.01 3.09 11.12V6.73C3.09 5.91 3.71 4.98 4.48 4.67L10.05 2.39C11.3 1.88 12.71 1.88 13.96 2.39L19.53 4.67C20.29 4.98 20.92 5.91 20.92 6.73L20.91 11.12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Safety Guidelines
              </span>
              <h2 className="text-[28px] md:text-[44px] lg:text-[60px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1] max-w-[578px]">
                Protect Your Team and Your Facility
              </h2>
            </div>
            <button className="flex items-center justify-center gap-2.5 py-3 px-4 bg-[#090d2c] rounded-[40px] hover:bg-[#3d405e] transition-colors w-fit shrink-0">
              <img src={downloadIcon} alt="" className="w-7 h-7" />
              <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white whitespace-nowrap">
                Download Safety Checklist
              </span>
            </button>
          </div>
        </Reveal>

        {/* Content: Illustration + Cards */}
        <Reveal direction="up">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16 lg:gap-20">
            {/* Warning Illustration */}
            <img
              src={warningIllustration}
              alt="Safety warning"
              className="w-full max-w-[400px] lg:w-[500px] shrink-0 rounded-[16px] h-auto"
            />

            {/* Safety Cards Grid */}
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {safetyCards.map((card, index) => (
                <div
                  key={index}
                  className="group rounded-[12px] bg-white border border-[rgba(98,99,108,0.2)] flex flex-col items-start justify-center py-3.5 px-4 md:py-4 md:px-5 gap-2 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] hover:border-[#e8e9ed] transition-all duration-300"
                >
                  {/* Tinted Icon Container */}
                  <div
                    className="w-8 h-8 md:w-9 md:h-9 rounded-[8px] flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                    style={{ backgroundColor: `${card.color}14` }}
                  >
                    {card.icon}
                  </div>
                  <h4 className="text-[15px] md:text-[17px] lg:text-[19px] font-semibold tracking-[-0.04em] text-black">
                    {card.title}
                  </h4>
                  <p className="text-[12px] md:text-[13px] lg:text-[14px] tracking-[-0.04em] leading-[1.5] text-[#62636c]">
                    {card.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
